<template>
    <div>
      <Menu v-if="!(this.$route.name==='Home')"></Menu>
      <router-view/>
      <Footer></Footer>
      <cookie-consent>
        <template
          slot="message"
          ref="cookie-message">
          <span id="cookieconsent:desc" class="cc-message">This website uses cookies to ensure you get the best experience on our website. <a aria-label="learn more about cookies" role="button" tabindex="0" class="cc-link" href="/cookie_policy" rel="noopener noreferrer nofollow" target="_blank">Learn more</a></span>
        </template>
        <template
          slot="button"
        >
          <button class="cc-btn cc-dismiss" id="gotit-btn">Got it!</button>
        </template>
      </cookie-consent>
    </div>
</template>
<script>
import Menu from './menu'
import Footer from './footer'
import CookieConsent from 'vue-cookieconsent-component'

export default {
  name: 'Front',
  components: {
    Menu,
    Footer,
    CookieConsent
  }
}
</script>

<style>
.template-container{
  margin: 0;
  padding: 0;
}
.cookie-consent{
  bottom: 0px;
  color: rgb(92, 114, 145);
  background-color: rgb(234, 247, 247) !important;
  font-family: Helvetica,Calibri,Arial,sans-serif;
  font-size: 16px;
  line-height: 2.5em !important;
  padding: 1em 1.8em !important;
  justify-content: left !important;
}
#gotit-btn{
  position: absolute;
  right: 20px;
  background-color: rgb(86, 203, 219);
  color: rgb(255, 255, 255);
  border-color: transparent;
  display: block;
  padding: .8em .8em;
  font-size: .9em;
  font-weight: 700;
  border-width: 2px;
  border-style: solid;
  text-align: center;
  white-space: nowrap;
  bottom: 15px
}
#gotit-btn:hover{
  background-color: rgb(124, 241, 255);
}
.cc-link{
  color: rgb(92, 114, 145);
}
</style>



// WEBPACK FOOTER //
// src/components/front/index.vue